import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

export default function Footer() {
    const { settings } = useSettings();
    const s = settings || {};
    return (
        <footer data-testid="site-footer" className="bg-[#1C1917] text-cream mt-20">
            <div className="container-padded py-16 md:py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="font-serif text-3xl mb-3">{s.business_name}</div>
                    <p className="text-stone-300 max-w-md text-sm leading-relaxed">
                        {s.tagline}. Designing and building bespoke wooden furniture, kitchens, doors and interiors across north India.
                    </p>
                    <div className="flex gap-4 mt-6">
                        {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 border border-stone-600 flex items-center justify-center hover:bg-walnut-light hover:border-walnut-light transition-colors"><Instagram size={16} /></a>}
                        {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-10 h-10 border border-stone-600 flex items-center justify-center hover:bg-walnut-light hover:border-walnut-light transition-colors"><Facebook size={16} /></a>}
                        {s.youtube && <a href={s.youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube" className="w-10 h-10 border border-stone-600 flex items-center justify-center hover:bg-walnut-light hover:border-walnut-light transition-colors"><Youtube size={16} /></a>}
                    </div>
                </div>

                <div>
                    <div className="overline mb-4">Explore</div>
                    <ul className="space-y-2 text-sm text-stone-300">
                        <li><Link to="/gallery" data-testid="footer-link-gallery" className="hover:text-walnut-light">Gallery</Link></li>
                        <li><Link to="/videos" data-testid="footer-link-videos" className="hover:text-walnut-light">Videos</Link></li>
                        <li><Link to="/services" data-testid="footer-link-services" className="hover:text-walnut-light">Services</Link></li>
                        <li><Link to="/about" data-testid="footer-link-about" className="hover:text-walnut-light">About</Link></li>
                        <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-walnut-light">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="overline mb-4">Workshop</div>
                    <ul className="space-y-3 text-sm text-stone-300">
                        <li className="flex gap-3"><MapPin size={16} className="shrink-0 mt-0.5" /><span data-testid="footer-address">{s.address}</span></li>
                        <li className="flex gap-3"><Phone size={16} className="shrink-0 mt-0.5" /><a href={`tel:${s.phone}`} data-testid="footer-phone">{s.phone}</a></li>
                        <li className="flex gap-3"><Mail size={16} className="shrink-0 mt-0.5" /><a href={`mailto:${s.email}`} data-testid="footer-email">{s.email}</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-stone-800">
                <div className="container-padded py-5 text-xs text-stone-400 flex flex-col md:flex-row justify-between gap-2">
                    <div>© {new Date().getFullYear()} {s.business_name}. All rights reserved.</div>
                    <div>Crafted in Mohali · Delivered across India</div>
                </div>
            </div>
        </footer>
    );
}
